export default {
      id: "画板(2)-usage",
      viewBox: "0 0 60 60",
      url: __webpack_public_path__ + "img/icons.a5c507dd.svg#画板(2)",
      toString: function () {
        return this.url;
      }
    }